import React from 'react';

import {PageWrapperLayout} from 'presentation/components';
import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {translations} from 'presentation/translations-new';
import {MakeCitySelection} from 'main/factories/pages';

const {title} = translations['pt-br'].privateFlow.requestAuthorizations.initialFlow;

export function RequestCities() {
	return (
		<PageWrapperLayout title={title}>
			<MakeCitySelection flowType={FlowEnum.AUTHORIZATIONS} />
		</PageWrapperLayout>
	);
}
